import { render, staticRenderFns } from "./ChevronDoubleLeftIcon.vue?vue&type=template&id=5292983c&scoped=true&"
import script from "./ChevronDoubleLeftIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronDoubleLeftIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5292983c",
  null
  
)

export default component.exports